const isRelativePath = (path) => {
  try {
    const decodedPath = decodeURIComponent(path);
    return decodedPath.startsWith("/") && !decodedPath.startsWith("//");
  } catch {
    return false;
  }
};

export default isRelativePath;
